module.exports = __webpack_public_path__ + "static/zoom-black-d53735e14c9bee91a20ae0e41cabc4c9.mp4";